/**
 * hiển thị theo
 */
export default {
  top: 1, // hiển thị ở trên
  bottom: 2, // hiển thị ở dưới
};
